import buchenImage from "../../../assets/fahrgestellnummer-pruefen/Buchen.png";
import phoneStatistics from "../../../assets/iphone-statistic.avif";
import phoneApp from "@/assets/iphone-app.avif";

import Image from "next/image";
import Link from "next/link";

export const Buchen = () => {
  return (
    <div className="CarValueBoxes Banner-Buchen">
      <div className="CVB-left">
        <Image
          src={buchenImage}
          alt="Wie viel ist dein Auto wert"
          className="autowertbestimmen"
        />

        <div className="CVB-left-text-wrapper">
          <h2>Wo befindet sich die Fahrgestell-nummer?</h2>
          <p>
            Die FIN ist eine 17-stellige Nummer, die jedes Fahrzeug eindeutig
            identifiziert. Sie sieht beispielsweise so aus:
            <strong> WVWZZZ1JZ3W386752</strong>.
          </p>

          <p>Sie befindet sich:</p>

          <ul>
            <li>
              <strong>Am Fahrzeug: </strong>
              Auf der Windschutzscheibe, im Türrahmen der Fahrerseite, im
              Motorraum oder auf der Lenksäule.
            </li>
            <li>
              <strong>In den Papieren: </strong>
              Im Zulassungsschein und Typenschein.
            </li>
            <li>
              <strong>Rechnungen: </strong>
              Auf Werkstattrechnungen
            </li>
          </ul>
          <p>Die genaue Position variiert je nach Hersteller und Modell.</p>
        </div>
      </div>
      <div className="Buchen-right">
        <div className="Buchen-right-first">
          <div className="Buchen-right-first-text-wrapper">
            <h4>Auto verkaufen zum Bestpreis</h4>
            <Link href="/auto-verkaufen">Auto Verkaufen</Link>
            <Image
              src={phoneApp}
              alt="Autoeinfachlos mobile"
              className="Buchen-right-app-img"
            />
          </div>
        </div>

        <div className="Buchen-right-second">
          <div className="Buchen-right-second-text-wrapper">
            <h4>Verfolge den Wert deines Autos</h4>
            <Link href="/auto-bewerten">Auto bewerten</Link>

            <Image
              src={phoneStatistics}
              alt="Autoeinfachlos mobile"
              className="Buchen-right-statictics-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
